<template>
	<div class="parent outline">

		<div style="display:inline-block; ">
			<p style="font-size:32px; font-weight:bold; margin:0px; width:49%; float:left;">{{column_data[1]}}</p>
			<p style="font-size:32px; font-weight:bold; margin:0px; width:49%; text-align: right; float:right;">Invoice</p>
		</div>

		<table class="hidetable" style="border:none">
			<tr>
				<td>Bill To</td>
				<td style="width:25%">
					<table>
						<tr>
							<td><b>Date</b></td>
							<td><b>Invoice #</b></td>
						</tr>
						<tr>
							<td>{{column_data[8]}}</td>
							<td></td>
						</tr>
					</table>
				</td>
			</tr>
			<tr>
				<td style="padding:0px; height:25px;">
					<p style="margin:0px;">{{column_data[2]}}</p>
				</td>
			</tr>
			<tr>
				<td style="padding:0px; height:25px;">
					<p style="margin:0px;">{{column_data[3]}}</p>
				</td>
			</tr>
			<tr>
				<td style="padding:0px; height:25px;">
					<p style="margin:0px;">{{column_data[4]}}</p>
				</td>
			</tr>
			<tr>
				<td style="padding:0px; height:25px;">
					<p style="margin:0px;">{{column_data[5]}}</p>
				</td>
			</tr>
			<tr>
				<td style="padding:0px; height:25px;">
					<p style="margin:0px;">{{column_data[6]}}</p>
				</td>
			</tr>
		</table>
		<table style="width:50%; margin-right:0px; margin-left:auto;">
			<tr>
				<td><b>P.O. No.</b></td>
				<td><b>Project</b></td>
			</tr>
			<tr>
				<td></td>
				<td><p>{{column_data[0]}}</p></td>
			</tr>
		</table>
		<table>
			<tr>
				<td style="width:10%"><p style="text-align: center;">Quantity</p></td>
				<td><p style="text-align: center;">Description</p></td>
				<td style="width:15%"><p style="text-align: center;">Rate</p></td>
				<td style="width:15%"><p style="text-align: center;">Amount</p></td>
			</tr>
			<tr class="hideborder">
				<td></td>
				<td><p style="white-space: pre-wrap;">{{column_data[7]}}<br/></p></td>
				<td></td>
				<td></td>
			</tr>
			<tr class="hideborder" v-for="(job,index) in jobs_column_data">
				<td></td>
				<td><p style="white-space: pre-wrap;">{{job[1]}}, {{job[7]}}, {{job[2]}}, {{job[5]}}<br v-if="index==jobs_column_data.length-1"/></p></td>
				<td></td>
				<td></td>
			</tr>
			<tr class="hideborder">
				<td>1</td>
				<td><p style="white-space: pre-wrap;">{{column_data[15]}}</p></td>
				<td>{{column_data[14]}}</td>
				<td>{{column_data[14]}}</td>
			</tr>
			<tr class="hideborder" v-if="column_data[11]!=0">
				<td>{{column_data[11]}}</td>
				<td><p style="white-space: pre-wrap;">{{column_data[16]}}</p></td>
				<td>{{column_data[12]}}</td>
				<td>{{column_data[13]}}</td>
			</tr>
			<tr>
				<td colspan=2>
					<p v-if="showMiscText==true">Thank you for your business.</p>
				</td>
				<td colspan=2>
					<b style="float:left; font-size:32px;">Total</b><p style="float:right">USD {{totalUSD}}</p>
				</td>
			</tr>
			<tr>
				<td colspan=4 style="text-align:center;">
					<p v-if="showMiscText==true">Terms of payment is Net 15 days, 2.5% compounded monthly interest on all late payments. Our Terms of Use located at www.LDpowerautomation.com/TermsofUse.pdf apply.</p>
				</td>
			</tr>
			<tr>
				<td colspan=4 style="text-align:center;">
					<p v-if="showMiscText==true">For questions, you can contact us at: tel +1 310 7071115, fax +1 310 6269486, e-mail accounting@ldpa.us</p>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
import {PAGES} from './../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term:Array,
		showMiscText:Boolean,
    },
	data() {
		return {
			pageid1:PAGES.CONTRACT_INVOICE_PREVIEW_PAGE,
			pageid2:PAGES.CONTRACT_JOBORDERS_LINKED_PAGE,

			column_data:[],
			jobs_column_data:[],
			totalUSD:0,
		}
	},
	async created (){
		this.search();
	},
	methods:{
		search(){
			api.postData({
				type:"search",
				data:{
					pageid:this.pageid1,
					data:[
						this.term
					],
				}
			}).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					if(res.data.data.column_data[0].length>0){
						this.column_data = res.data.data.column_data[0];

						var month = this.monthToName(parseInt(this.term[2].substr(5,2)));
						var year = this.term[2].substr(0,4)

						this.column_data[7]=this.column_data[7].replace("<month>",month)
						this.column_data[7]=this.column_data[7].replace("<year>",year)
						this.totalUSD = parseFloat(this.column_data[13])+parseFloat(this.column_data[14])
					}
				}
			})

			api.postData({
				type:"search",
				data:{
					pageid:this.pageid2,
					data:[
						this.term
					],
				}
			}).then((res) => {
				if(res.data.data!=null && res.data.data.column_data!=null){
					if(res.data.data.column_data[0].length>0){
						this.jobs_column_data = res.data.data.column_data;
					}
				}
			})
		},
		monthToName(month){
			switch(month){
				case 1:return 'January'
				case 2:return 'February'
				case 3:return 'March'
				case 4:return 'April'
				case 5:return 'May'
				case 6:return 'June'
				case 7:return 'July'
				case 8:return 'August'
				case 9:return 'September'
				case 10:return 'October'
				case 11:return 'November'
				case 12:return 'December'
				default:return 'null'
			}
		}
	},
	watch:{

	},
}
</script>

<style scoped>
.outline {
	border: 2px solid black;
	padding:5px;
}

.hidetable > tr > td {
	border: none;
	table-layout:fixed;
	background-color: #ffffff;
	border-collapse: collapse;
	empty-cells: show;
}

.hideborder > td {
	 border-top: none;
	 border-bottom: none;
}

p{
	padding:0px;
	margin:0px;
}

.overlap {
	padding:0px 5px 0px 5px;
	font-size:15px;
	font-weight: bold;
	color:#000000;
	background-color:#ffcfcf;
	border-radius: 5px;
	border:2px solid #d62929;
	margin:0px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/layout_13.vue